export default __webpack_public_path__ + "static/media/craon4.5935f451.jpg";